<template>
    <div class="container gy-5">
        <div class="row align-items-center justify-content-start my-4">
            <div class="flex-grow-0 col" v-if="canAddPage">
                <el-button type="primary" icon="Plus" @click="editedPage = {}; openEditPageDialog()">Create New Page</el-button>
            </div>
        </div>
    </div>

    <el-table stripe style="width: 100%" table-layout="auto" v-loading="pagesLoading" :data="pages">
        <el-table-column label="Title">
            <template #default="scope">
                <strong>{{ scope.row.title }}</strong>
                <el-tag class="ms-2" size="large" effect="dark" type="success" v-if="scope.row.visible">Visible</el-tag>
                <el-tag class="ms-2" size="large" effect="dark" type="info" v-else>Hidden</el-tag>
                <el-tag class="ms-2" size="large" type="success" v-if="scope.row.guest_visible">Public</el-tag>
                <el-tag class="ms-2" size="large" type="info" v-else>Registered users only</el-tag>
            </template>
        </el-table-column>
        <el-table-column label="URL" prop="slug" />
        <el-table-column label="Last updated">
            <template #default="scope">
                {{ $datetime(scope.row.last_update) }}
            </template>
        </el-table-column>
        <el-table-column label="Actions">
            <template #default="scope">
                <el-button v-if="canEditPages || scope.row.visible" type="primary" icon="View" @click = "$router.push({name: 'StaticPage', params: { slug: scope.row.slug }})">View</el-button>
                <el-button v-if="canEditPages" type="primary" icon="Edit" @click = " editedPage = {...scope.row}; openEditPageDialog() ">Edit</el-button>
            </template>
        </el-table-column>
    </el-table>

    <el-dialog v-model="editPageDialogVisible" title="Create new page" width="800px">
            <div>
                <EditPageForm @created="editedPage = {}; fetchPages(); closeEditPageDialog()" @saved="closeEditPageDialog(); fetchPages()" v-model="editedPage" @cancel="closeEditPageDialog" />
            </div>
        </el-dialog>
</template>

<script>
import api from '@/lib/api'

import { mapGetters } from 'vuex'

import EditPageForm from '@/components/pages/EditPageForm.vue'

export default {
    name: 'PagesTable',

    components: { EditPageForm },

    data: () => {
        return {
            pages: [],
            pagesLoading: false,
            editPageDialogVisible: false,
            editedPage: {}
        }
    },

    computed: {
        ...mapGetters ( 'auth', ['allowed'] ),

        canAddPage () {
            return this.allowed ( 'create-static-page' )
        },

        canEditPages () {
            return this.allowed ( 'edit-static-page' )
        }
    },

    methods: {
        fetchPages () {
            this.pagesLoading = true
            api.pages.fetchAll()
            .then ( response => {
                this.pages = response.data

                console.log (this.pages)
            })
            .catch(error => {
                const err = error?.response?.data?.message || error.message

                this.$notify({
                    title: 'Error',
                    message: `Could not load pages: ${err}`,
                    type: 'error'
                })
            })
            .finally (() => {
                this.pagesLoading = false
            })
        },

        openEditPageDialog () {
            this.editPageDialogVisible = true
        },

        closeEditPageDialog () {
            this.editPageDialogVisible = false
        }
    },

    mounted () {
        this.fetchPages()
    }
}
</script>